var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-table',{staticClass:"m-t-20",attrs:{"firstIndex":false,"firstIndexOne":"","checked":false,"rowKey":"id","checkSelectable":true,"tableData":_vm.table.list,"columns":_vm.state === '已完成' || !_vm.showButton?_vm.tableCol1:_vm.tableCol},on:{"handleDelete":_vm.handleDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }